/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-21 16:23:55
 */
import { CaretDownFilled, CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, DatePicker, Form, Image, Input, InputNumber, Modal, notification, Radio, Row, Select, Spin } from 'antd'
import { UploadFile } from 'antd/lib/upload/interface'
import { number } from 'echarts'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import FileUpload from '../../compnents/file/FileUpload'
import { DiseaseInput } from '../../compnents/input/DiseaseInput'
import { EditableList } from '../../compnents/list/EditableList'
import { DateTimeFormatMessageSimple } from '../../models/datetime'
import { getOrgaztionnName } from '../../models/notifiction'
import { List } from '../../models/page'
import { ProvincePageParams } from '../../services/insurance'
import { ThemeContext } from '../../theme/ThemeContext'
import { getDetailData, getDetailData2 } from '../message/NotificationCenter/notificationCenterSlice'
import { selectInsuranceArray } from '../tenant/setting/TenentSettingSlice'
import { getLabelList } from '../tenant/tenantSlice'
import { getUrl } from '../treatment/diagnosis/diagnosisSlice'
import styles from './advertising.module.css'
import { advertisingAsync, advertisingAsync2, advertisingListAsync, deleteList, updateList, updateList2 } from './advertisingSlice'
import { Columns } from './Columns'

const { Option } = Select;
export const Advertising = () => {
  const theme = useContext(ThemeContext)

  const [queryForm] = Form.useForm();

  const [form] = Form.useForm();

  const { RangePicker } = DatePicker

  const dispatch = useDispatch<RootDispatch>()

  const [modalVisible, setModalVisible] = useState(false)

  const [uploadLoading, setUploadLoading] = useState(false)

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [pageLoading, setPageLoading] = useState(false)

  const [imgId, setImgId] = useState('')

  const [modalTitle, setModalTitle] = useState('新增')


  const [data, setData] = useState<any>({})

  const [imgSrc, setImgSrc] = useState('')

  const [fileName, setFileName] = useState('')


  const [queries, setQueries] = useState<ProvincePageParams>({
    size: 10,
    current: 1,
  })

  const [selectedOrgazations, setSelectedOrgazations] = useState<any[]>([]) //接受机构为指定机构时的列表的机构名称们

  const [acceptOrgazation, setAcceptOrgazation] = useState<any>() //详情接受机构的字段

  const [isOnlyOrgaztionEmpty, setIsOnlyOrgaztionEmpty] = useState(false)

  const [labelList, setLabelList] = useState<any>([])   //标签数据

  const [tenantIdList, setTenantIdList] = useState<any>([]) //编辑时传的值

  const [homeImg, setHomeImg] = useState<any>(0)



  const labelData = () => {
    dispatch(
      getLabelList({
        current: 1,
        size: 1000
      })
    )
      .then(unwrapResult)
      .then((res) => setLabelList(res.records))
  }
  const institutionsIpt = (id: number) => {     //获取指定机构信息
    dispatch(getDetailData2({ id }))
      .then(unwrapResult)
      .then((v: any) => {
        setSelectedOrgazations(
          v &&
          v?.tenantIdInfoVos?.map((v: any) => {
            return { name: v?.tenantName, id: v?.tenantId }
          })
        )
      })
  }

  useEffect(() => {
    labelData()
  }, [])

  useEffect(() => {
    getData()
  }, [queries])

  // 指定机构时的传参
  useEffect(() => {
    if (selectedOrgazations) {
      setTenantIdList(selectedOrgazations?.map((v) => v?.id))

    }
  }, [selectedOrgazations])

  // 接收机构下拉框非指定机构时的展示
  useEffect(() => {
    if (acceptOrgazation != 2 && acceptOrgazation != 3) {
      setSelectedOrgazations(
        acceptOrgazation
          ? [{ name: getOrgaztionnName(String(acceptOrgazation)) }]
          : []
      )
    }
  }, [acceptOrgazation])

  const getData = () => {
    setPageLoading(true)
    dispatch(advertisingListAsync(queries)).then(unwrapResult).then((res: any) => setData(res))
      .finally(() => setPageLoading(false))
  }

  const close = () => {
    setModalVisible(false)
    setSelectedOrgazations([])
    setAcceptOrgazation('')
    setImgSrc('')
    setHomeImg(0)
    form.resetFields()



  }

  const updateListFn = (call: any) => {   //新增or 编辑

    dispatch(call).then(unwrapResult).then(() => {
      notification.success({
        message: `${modalTitle}成功`
      })
      getData()
      close()
    })
  }
  return (
    <div className={styles.content}>
      <Form
        form={queryForm}
        style={{ display: 'flex', justifyContent: 'space-between' }}
        initialValues={{ time: 0 }}
        onFinish={(values) => {
          setQueries({
            ...queries,
            ...values,
            current: 1,
          })
        }}
        autoComplete='off'
      >
        <Row style={{ flex: 1 }}>
          <Col span={3}>
            <Form.Item name='platformType'>
              <Select
                placeholder='展示位置'
                allowClear
                suffixIcon={<CaretDownFilled />}
                onChange={queryForm.submit}
              >
                <Option value={0}>机构端登录页</Option>
                <Option value={1}>机构端首页</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={3} style={{ marginLeft: 15 }}>
            <Form.Item name='status'>
              <Select
                placeholder='状态'
                allowClear
                suffixIcon={<CaretDownFilled />}
                onChange={queryForm.submit}
              >
                <Option value={1}>禁用</Option>
                <Option value={0}>正常</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={2} offset={2}>
            <Button htmlType='submit' type='primary'>
              搜索
            </Button>
          </Col>
        </Row>
        <Button
          type='primary'
          onClick={() => {
            setModalVisible(true)
            setModalTitle('新增')
          }}
        >
          新增
        </Button>
      </Form>
      {/* <Row justify='end' style={{ margin: '10px 0' }}>
        <Button type='primary' onClick={() => {
          setModalVisible(true)
          setModalTitle('新增')
        }}>新增</Button>
      </Row> */}
      <EditableList
        style={{ color: theme.tc3 }}
        loading={pageLoading}
        className={styles.table}
        columns={Columns((action, id, t) => {
          if (action == 'edit') {
            //编辑
            setImgId(id)
            t.acceptTenant == 2 && institutionsIpt(t.id)
            setImgSrc(t.imgUrlPath)
            setFileName(t.imgUrl)
            setModalTitle('编辑')
            form.setFieldsValue({
              ...t,
              acceptTenant: t?.acceptTenant?.toString(),
              tenantIdList:
                t.acceptTenant == 2
                  ? []
                  : t.labelIds.split(',').map((item: any) => Number(item)),
              time: [moment(t?.startTime) || '', moment(t?.endTime) || ''],
            })
            setHomeImg(t.platformType)
            setAcceptOrgazation(t.acceptTenant)
            setModalVisible(true)
          } else if (action == 'delete') {
            //删除
            dispatch(deleteList({ id }))
              .then(unwrapResult)
              .then(() => {
                notification.success({ message: '删除成功' })
                getData()
              })
          }
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10,
          })
        }}
      />
      <Modal
        visible={modalVisible}
        title={modalTitle}
        width={800}
        onCancel={close}
        onOk={() => {
          form.submit()
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          onFinish={(vs) => {
            const data = {
              ...vs,
              imgUrl: fileName,
              link: vs.link,
              // seq: vs.seq,
              startTime: vs?.time?.[0]?.format(DateTimeFormatMessageSimple),
              endTime: vs?.time?.[1]?.format(DateTimeFormatMessageSimple),
              time: undefined,
              status: vs.status,
              id: modalTitle == '编辑' ? imgId : undefined,
              targetTenantId:
                homeImg == 0
                  ? undefined
                  : acceptOrgazation == 2
                  ? tenantIdList.join(',')
                  : undefined,
              labelIds: vs.tenantIdList?.length
                ? vs.tenantIdList?.join(',')
                : undefined,
            }
            // modalTitle == '新增' ? updateListFn(advertisingAsync(data)) : updateListFn(updateList(data))
            if (modalTitle == '新增') {
              if (homeImg == 0) {
                updateListFn(advertisingAsync(data))
              } else if (homeImg == 1) {
                updateListFn(advertisingAsync2(data))
              }
            } else {
              if (homeImg == 0) {
                updateListFn(updateList(data))
              } else if (homeImg == 1) {
                updateListFn(updateList2(data))
              }
            }
          }}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 15 }}
          initialValues={{
            status: 0,
            platformType: 0,
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name='platformType'
                label='展示平台位置'
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  disabled={modalTitle == '编辑'}
                  onChange={(v) => {
                    const value = v.target.value
                    setHomeImg(value)
                  }}
                >
                  <Radio value={0}> 机构端登录页 </Radio>
                  <Radio value={1}> 机构端首页 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name='imgUrl'
                label='轮播图片'
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {imgSrc ? (
                  <div>
                    <Image src={imgSrc} style={{ width: 100, height: 100 }} />
                    <div
                      className={styles.deleteImg}
                      onClick={() => {
                        setImgSrc('')
                        form.setFieldsValue({
                          imgUrl: '',
                        })
                      }}
                    >
                      删除图片
                    </div>
                  </div>
                ) : (
                  <Spin spinning={uploadLoading}>
                    <div className={styles.imgContainer}>
                      <FileUpload
                        count={fileList.length || 0}
                        maxCount={1}
                        files={fileList}
                        accept={'.png,.jpg,.webp,.jpeg,.tiff,.heic,bmp'}
                        beforeUpload={(file) => {
                          // setBtnLoading(true)
                          if (
                            file.type.includes('png') ||
                            file.type.includes('tiff') ||
                            file.type.includes('jpg') ||
                            file.type.includes('jpeg') ||
                            file.type.includes('bmp') ||
                            file.type.includes('heic') ||
                            file.type.includes('webp')
                          ) {
                            if (file.size / 1024 / 1024 < 5) {
                              setUploadLoading(true)
                              return true
                            } else {
                              notification.info({
                                message: '图片大于5M,请重新选择!',
                              })
                              // setBtnLoading(false)
                              return false
                            }
                          }
                          // setBtnLoading(false)
                          notification.info({ message: '请上传图片' })

                          return false
                        }}
                        onUpload={(v, i) => {
                          setFileName(i)
                          dispatch(getUrl({ fileName: i }))
                            .then(unwrapResult)
                            .then((res: any) => setImgSrc(res))
                            .finally(() => setUploadLoading(false))
                        }}
                      >
                        <div className={styles.upload}>
                          <PlusOutlined />
                        </div>
                      </FileUpload>
                      建议图片尺寸 750*500
                    </div>
                  </Spin>
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name='status' label='广告状态'>
                <Radio.Group>
                  <Radio value={1}> 禁用 </Radio>
                  <Radio value={0}> 正常 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {homeImg == 0 && (
              <Col span={24}>
                <Form.Item
                  rules={[{ required: true }]}
                  name='seq'
                  label='轮播图顺序'
                >
                  <InputNumber min={0} step={1} />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item name='link' label='超链接'>
                <Input.TextArea />
              </Form.Item>
            </Col>
            {homeImg == 1 && (
              <>
                <Col span={12}>
                  <Form.Item
                    labelCol={{ span: 12 }}
                    label='接收机构'
                    name='acceptTenant'
                    style={{ marginRight: '10px' }}
                    rules={[
                      {
                        required: true,
                        message: '请选择接收机构！',
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      placeholder='请选择机构'
                      onChange={(v: any) => {
                        setAcceptOrgazation(v)
                        if (v == 2 || v == 3) {
                          setSelectedOrgazations([])
                          form.setFieldsValue({
                            tenantIdList: [],
                          })
                        }
                      }}
                    >
                      <Select.Option value={'0'}>所有机构</Select.Option>
                      <Select.Option value={'1'}>医保机构</Select.Option>
                      <Select.Option value={'2'}>指定机构</Select.Option>
                      <Select.Option value={'3'}>按标签</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                {acceptOrgazation == 2 && (
                  <Col span={12}>
                    <Form.Item
                      name='tenantIdList'
                      rules={[
                        () => ({
                          validator: () => {
                            if (isOnlyOrgaztionEmpty) {
                              return Promise.reject('请输入机构名称')
                            }
                            return Promise.resolve()
                          },
                        }),
                      ]}
                    >
                      <DiseaseInput
                        NoticeTag={true}
                        placeholder='请输入机构名称以检索'
                        onChange={() => setIsOnlyOrgaztionEmpty(false)}
                        onSelect={(disease) => {
                          if (
                            !selectedOrgazations.find(
                              (d: any) => d?.id === disease?.id
                            )
                          ) {
                            setSelectedOrgazations(
                              selectedOrgazations.concat(disease)
                            )
                            form.resetFields(['tenantIdList'])
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                )}
                {selectedOrgazations?.length != 0 && (
                  <Col
                    span={24}
                    style={{
                      borderRadius: 2,
                      border: `1px solid ${theme.wbd}`,
                      padding: '5px 5px 0 5px',
                      marginRight: 10,
                      marginBottom: 23,
                    }}
                  >
                    {selectedOrgazations.map((d: any) => (
                      <div key={d.id} className={styles.disease}>
                        {`${d.name}`}
                        {acceptOrgazation == 2 && (
                          <CloseOutlined
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setSelectedOrgazations(
                                acceptOrgazation == 2
                                  ? selectedOrgazations.filter(
                                      (i: any) => i?.id !== d?.id
                                    )
                                  : selectedOrgazations.filter(
                                      (i: any) => i !== d
                                    )
                              )
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </Col>
                )}

                {acceptOrgazation == 3 && (
                  <Col span={12}>
                    <Form.Item
                      name='tenantIdList'
                      rules={[
                        {
                          required: true,
                          message: '请选择标签！',
                        },
                      ]}
                    >
                      <Select
                        mode='tags'
                        suffixIcon={
                          <CaretDownFilled style={{ color: theme.tc3 }} />
                        }
                        placeholder='标签-全部'
                        allowClear
                        style={{ width: '100%' }}
                      >
                        {labelList.map((c: any) => (
                          <Select.Option key={c.id} value={c.id}>
                            {c.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                <Col span={24}>
                  <Form.Item
                    label='通知生效时间'
                    name='time'
                    style={{ marginRight: '10px' }}
                    rules={[
                      {
                        required: true,
                        message: '请选择生效时间',
                      },
                    ]}
                  >
                    <RangePicker showTime />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </Modal>
    </div>
  )
}
